import { useQuery } from "@tanstack/react-query";
import { fetchSerialKillers } from "../../api/serial-killers";
import type { SerialKillerListItemDTO } from "@shared/contracts";
import { STALE_TIME } from "../../utils/constants";


export function useSerialKillers() {
  return useQuery<SerialKillerListItemDTO[]>({
    queryKey: ["serialKillers"],
    queryFn: ({ signal }) => fetchSerialKillers(signal),
    staleTime: STALE_TIME,
  });
}